import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { IContactFormProps } from './contact-form.props.autogenerated';
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* tslint:disable: no-duplicate-imports */

// tslint:disable-next-line: no-any
export interface IContactFormExtendedProps extends IContactFormProps<any> {
    className?: string;
    captchaKey?: string;
    textBox:React.ReactNode;
}

/**
 *
 * Form component
 */
class ContactForm extends React.Component<IContactFormExtendedProps> {

    constructor(props: IContactFormExtendedProps) {
        super(props);
    }

    public componentDidMount(): void {
        const script = document.createElement('script');
        script.src =
          'https://www.google.com/recaptcha/api.js';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
      }

    public render(): JSX.Element | null {
        const{textBox}=this.props.config;
        const textBoxField=textBox&&(
            <Msdyn365.RichTextComponent text={textBox}/>
        );
        const ContactViewProps={
            ...this.props,
            textBox:textBoxField
        }
        return this.props.renderView(ContactViewProps);
    }
}

export default ContactForm;
